exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".order-denied-page .order-id {\n  color: #ef3d42;\n  font-weight: bold;\n  letter-spacing: 0.1px; }\n\n.order-denied-page .try-again {\n  color: #8b3187;\n  text-decoration: underline;\n  cursor: pointer; }\n\n.order-denied-page .expire-date {\n  font-weight: bold; }\n\n.order-denied-page .contact-information {\n  margin-top: 3.5rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/OrderDeniedPage/OrderDeniedPage.scss
// module id = 1714
// module chunks = 0